import * as React from 'react';

import type {ConditionStatus} from 'nutshell-graphql-types';

import {colors} from '../../colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {TickCircleIcon} from '../../icon/svg/tick-circle-icon';
import {WarningIcon} from '../../icon/svg/warning-icon';
import {Stack} from '../../layout/stack/stack';
import {Body} from '../../typography/body';

type Props = {
    status: ConditionStatus;
};

export function GoalStatus(props: Props) {
    const getStatusInfo = (status: ConditionStatus) => {
        switch (status) {
            case 'MISSING_CUSTOM_FIELD_ERROR':
                return {
                    message: 'This goal needs to be updated - the field no longer exists',
                    // @ts-expect-error
                    icon: <WarningIcon color={colors.yellow} wrapWithDiv={false} size={14} />,
                };
            case 'UNKNOWN_ERROR':
                return {
                    message:
                        'Something went wrong checking this goal. Please check that it is properly configured.',
                    // @ts-expect-error
                    icon: <WarningIcon color={colors.yellow} wrapWithDiv={false} size={14} />,
                };
            case 'FULFILLED':
                return {
                    message: 'Completed',
                    icon: <TickCircleIcon color={colors.green} wrapWithDiv={false} size={14} />,
                };
            default:
                return null;
        }
    };

    const statusInfo = getStatusInfo(props.status);

    if (!statusInfo) {
        return null;
    }

    return (
        <Stack spacing={4} isHorizontal={true} alignItems='center' isFullWidth={true}>
            {statusInfo.icon}
            <Body size='small'>{statusInfo.message}</Body>
        </Stack>
    );
}
